export default __webpack_public_path__ + "static/media/Jeronimo.22cbcb8e.jpg";